import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { SubmitFeedbackRequest } from "../contracts/SubmitFeedbackRequest";
import { FeedbackResponse } from "../contracts/FeedbackResponse";
import { FeedbackType } from "../enums/FeedbackType";

export interface SubmitFeedbackArgs {
  type: FeedbackType;
  message: string;
}

/** Sends a wish / issue report / note from the signed-in instructor to us. */
export const submitFeedback = createAsyncThunk<
  FeedbackResponse,
  SubmitFeedbackArgs,
  { rejectValue: ApiErrorResponse }
>("feedback/submit", async ({ type, message }, { rejectWithValue }) => {
  try {
    const request: SubmitFeedbackRequest = { type, message };
    const response = await axiosInstance.post<FeedbackResponse>("/feedback", request);
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to send feedback"));
  }
});
